// extracted by mini-css-extract-plugin
export default {"header":"Header_header__F6N3O","mainPoster":"Header_mainPoster__gvFly","bottomShadow":"Header_bottomShadow__aY28m"};